import { iaRa } from 'lib/helpers/utility';
import { downloadPdf } from 'lib/helpers/pdf/download/download';
import { printTable } from 'lib/helpers/pdf/tableExport/printPdf';
import { MAX_COLUMNS_PER_CATEGORY } from 'lib/helpers/pdf/tableExport/lib/constants';

import { showAlert } from 'components/shared/Alert/Alert';

import { applyColumnFormatters } from './applyColumnFormatters';

export const exportPdfWithFallback = async ({
  navigate,
  values,
  data,
  name,
  isDetailedMode,
  finalColumns,
  finalParentColumns,
  statusPanelData,
  withTotals = false,
  headerConfigs,
  exportApiProps
}) => {
  const columns = isDetailedMode ? finalParentColumns : finalColumns;
  const childColumns = isDetailedMode ? finalColumns : undefined;
  const maxColumns = MAX_COLUMNS_PER_CATEGORY?.[name];
  // A report's panel figures are its totals (see describeMeasures); other tables' panels can cover
  // more rows than a page export holds, so their totals are summed from the exported rows.
  const panelData = iaRa(statusPanelData).map(({ field, label, value }) => ({
    field,
    label,
    ...(withTotals && { value })
  }));

  const { rows: formattedData, columns: formattedColumns } = applyColumnFormatters({
    rows: data,
    columns,
    excludedFields: panelData.map(({ field }) => field)
  });

  const isGenerated = await downloadPdf({
    navigate,
    title: values.title,
    exportApiProps: {
      data: formattedData,
      columnDefs: formattedColumns,
      childColumns,
      printExpandedRows: isDetailedMode,
      maxColumns,
      headerConfigs,
      orientation: values.orientation,
      statusPanelData: panelData,
      ...exportApiProps
    }
  });

  if (isGenerated) return;

  showAlert({
    title: "Couldn't generate the PDF on the server — used the legacy exporter instead.",
    color: 'warning'
  });

  printTable({
    category: name,
    tableData: data,
    columns,
    childColumns,
    filterHiddenColumns: false,
    statusPanelData: panelData,
    printExpandedRows: isDetailedMode,
    orientation: values.orientation,
    maxColumns,
    headerConfigs
  });
};
